/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * @module LogsModule
 */

import {
    Component,
    ElementRef,
    Input,
    Renderer2,
} from '@angular/core';

import './log-cinematic-sub-section-wrapper.component.less';

const componentName = 'log-cinematic-sub-section-wrapper';

/**
 * @description
 *
 *  Wrapper component to be used by sub-sections in a log cinematic view for header setting and container styling.
 *
 * @author Zhiqian Liu
 */
@Component({
    selector: 'log-cinematic-sub-section-wrapper',
    templateUrl: './log-cinematic-sub-section-wrapper.component.html',
})
export class LogCinematicSubSectionWrapperComponent {
    /**
     * Text as the sub-section header.
     */
    @Input()
    public header: string;

    constructor(
        renderer: Renderer2,
        elementRef: ElementRef,
    ) {
        const hostElement = elementRef.nativeElement;

        // adding host class here rather than setting it in .less is to make sure :not(:first-child)
        // work for a list of sub section wrapper components
        renderer.addClass(hostElement, componentName);
    }
}
